import * as actions from '../constants/actions';
import { checkHttpStatus } from '../utils';
import * as api from '../utils/api';

const fetchData = (request, successAction, failureAction = null) => (dispatch) => {
  fetch(request)
    .then(checkHttpStatus)
    .then(res => res.json())
    .then((data) => {
      const successActions = Array.isArray(successAction) ? successAction : [successAction];
      successActions.forEach((action) => dispatch(action(data)));
    })
    .catch((error) => {
      if (failureAction) {
        const failureActions = Array.isArray(failureAction) ? failureAction : [failureAction];
        failureActions.forEach((action) => dispatch(action(error)));
      } else {
        throw error;
      }
    });
};

export const requestFetchRegions = () => ({
  type: actions.FETCH_REGIONS_REQUEST,
});

export const receiveFetchRegions = (timeSpan, result) => ({
  type: actions.FETCH_REGIONS_RECEIVE,
  timeSpan,
  result,
});

export const fetchRegions = (timeSpan) => (dispatch) => {
  dispatch(requestFetchRegions());
  dispatch(fetchData(
    api.get('regions', { timeSpan }), (res) => receiveFetchRegions(timeSpan, res)));
};

export const selectRegion = (region) => ({
  type: actions.SELECT_REGION,
  region,
});

export const requestFetchMessage = () => ({
  type: actions.FETCH_MESSAGE_REQUEST,
});

export const receiveFetchMessage = (result) => ({
  type: actions.FETCH_MESSAGE_RECEIVE,
  result,
});

export const fetchMessage = () => (dispatch) => {
  dispatch(requestFetchMessage());
  dispatch(fetchData(api.get('message'), receiveFetchMessage));
};

export const requestFetchGraph = () => ({
  type: actions.FETCH_GRAPH_REQUEST,
});

export const receiveFetchGraph = (result) => ({
  type: actions.FETCH_GRAPH_RECEIVE,
  result,
});

export const fetchGraph = () => (dispatch) => {
  dispatch(requestFetchGraph());
  dispatch(fetchData(api.get('graph'), receiveFetchGraph));
};

export const selectTimeSpan = (timeSpan) => (dispatch) => {
  dispatch({
    type: actions.SELECT_TIME_SPAN,
    timeSpan,
  });
  dispatch(fetchRegions(timeSpan));
};



// WEBPACK FOOTER //
// ./src/actions/index.js